// extracted by mini-css-extract-plugin
module.exports = {"techItem":"TechStackItem_techItem__3XhfR","techItemImg":"TechStackItem_techItemImg__1wrE_","techItemName":"TechStackItem_techItemName__2vugM"};